module.exports = __webpack_public_path__ + "img/ASN2026.c13eedf8.png";